import React, { useEffect, useState } from 'react'

// Components
import { Modal, Tag, Input, notification } from "antd";

const ScraperModal = ({ openModal, setOpenModal, addKeywords, getListKeywords }) => {
    const [inputValue, setInputValue] = useState("");
    const [keywordTags, setKeywordTags] = useState([]);
    const [loading, setLoading] = useState(false);
    const [keywordExist, setKeywordExist] = useState([]);

    const handleAdd = async () => {
        if (!keywordTags.length) return;
        try {
            setLoading(true);
            const response = await addKeywords(keywordTags);
            const { already_scraped_keywords, message } = response.data;
            setKeywordExist(already_scraped_keywords);
            setLoading(false);
            if (message === "Success!") {
                const successCount = keywordTags.length - already_scraped_keywords.length;
                if (successCount) {
                    notification.success({
                        message: "Success!",
                        description: `${successCount} keyword(s) successfully added.`,
                        duration: 5,
                        placement: "topRight",
                    });
                }

                if (!already_scraped_keywords.length) setOpenModal(false)
                getListKeywords();
            } else throw message
        } catch (error) {
            setLoading(false);
            notification.error({
                message: "Error!",
                description: "Error adding keyword(s). Please try again.",
                duration: 5,
                placement: "topRight",
            });
            console.error(error)
        }
    }

    const handleEnter = (value) => {
        if (value && !keywordTags.includes(value)) {
            keywordTags.push(value);
        }
        setInputValue("");
    };

    const removeTag = (value) => {
        setKeywordTags(keywordTags.filter((text) => text !== value));
    };

    useEffect(() => {
        if (openModal) {
            setInputValue("");
            setKeywordTags([]);
            setKeywordExist([])
        }
    }, [openModal]);

    return (
        <Modal
            centered
            className="report--freeformmodal"
            open={openModal}
            closable={false}
            maskClosable={false}
            title={(
                <div className="d-flex" style={{ width: "100%" }}>
                    <div className="d-flex-col flex-1">
                        <b className="report--freeformmodal--title">Add Topic/Brand</b>
                        <p className="report--freeformmodal--subtitle" style={{ fontSize: "12px", color: "#94A3B8" }}>Type the topic or brand name you would like to add to the list.</p>
                    </div>
                </div>
            )}
            okText="Add"
            okButtonProps={{
                disabled: !keywordTags.length,
                loading: loading
            }}
            onCancel={() => {
                setOpenModal(false);
            }}
            onOk={handleAdd}
        >
            <div className="report--freeformmodal--container d-flex-col">
                {
                    !!keywordTags.length && (
                        <div className="report--freeformmodal--tagcontainer" key="tagSectionKey">
                            {keywordTags.map((item) => (
                                <Tag className="oi-tag" closable onClose={() => removeTag(item)} key={item}>{item}</Tag>
                            ))}
                        </div>
                    )
                }
                <Input.TextArea
                    className="flex-1"
                    style={{
                        height: "100%",
                        resize: "none",
                    }}
                    bordered={false}
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    onPressEnter={(e) => {
                        handleEnter(inputValue.trim());
                    }}
                    onBlur={(e) => {
                        handleEnter(inputValue.trim());
                    }}
                />

            </div>
            <div className='d-flex justify-content-between'>
                <p style={{ fontSize: "13px", color: "#713F12" }}>{keywordExist.length ? `"${keywordExist.join(",")}" have already been added to the list.` : null}</p>
                <p style={{ fontSize: "12px", color: "#64748B" }}>Total: {keywordTags.length}</p>
            </div>

        </Modal>
    )
}

export default ScraperModal